import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withFocusedState from "../../../enhancers/withFocusedState";
import TextField from '../TextField';
import "./TextArea.css";

var TextArea =
/** @class */
function (_super) {
  tslib_1.__extends(TextArea, _super);

  function TextArea() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleResize = function () {
      if (!_this.props.autosize || !_this.inputRef) return;
      _this.inputRef.style.height = 'auto';
      _this.inputRef.style.height = _this.inputRef.scrollHeight + "px";
      _this.inputRef.scrollTop = _this.inputRef.scrollHeight;
    };

    return _this;
  }

  TextArea.prototype.componentDidMount = function () {
    // Call immediately to prevent component gets shrunk in height on page refresh
    this.handleResize(); // Wait until the custom fonts are applied.

    setTimeout(this.handleResize);
  };

  TextArea.prototype.componentDidUpdate = function () {
    this.handleResize();
  };

  TextArea.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        inputClassName = _a.inputClassName,
        autosize = _a.autosize,
        // eslint-disable-line no-unused-vars
    other = tslib_1.__rest(_a, ["className", "inputClassName", "autosize"]);

    return React.createElement(TextField, tslib_1.__assign({}, other, {
      type: "textarea",
      className: cx('nx-textarea', className),
      inputClassName: cx('nx-textarea__input', inputClassName),
      inputRef: function inputRef(input) {
        return _this.inputRef = input;
      }
    }));
  };

  TextArea.displayName = 'TextArea';
  TextArea.propTypes = tslib_1.__assign({}, TextField.propTypes, {
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    rows: PropTypes.number,
    autosize: PropTypes.bool
  });
  TextArea.defaultProps = {
    /** Native <textarea> prop, works as calculated height (or min-height, if autosize is enabled). */
    rows: 2,
    autosize: true
  };
  return TextArea;
}(Component);

export default withFocusedState(TextArea);

try {
  // @ts-ignore
  TextArea.__docgenInfo = {
    "description": "",
    "displayName": "TextArea",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}